/* eslint-disable react-hooks/rules-of-hooks */
import React, { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { usePermission } from '@ab-inbev/sam-auth';
import { FeatureFlagNames, useFeatureFlags } from '@ab-inbev/sam-feature-flags';
import { AppName, EnhancedPermissionsDisplayData, EnhancedPermissionsSet, PermissionsDisplayData } from './types';
import { userGuideLink } from '../constants';
import { PermissionDisplayLine } from './PermissionDisplayLine';
import { UserInfoDisplay } from '../UserInfoDisplay';

export type PermissionDisplayProps = {
  listOfPermissions: PermissionsDisplayData[];
  appName: AppName;
};

export const PermissionsDisplay: FC<PermissionDisplayProps> = ({ listOfPermissions, appName }) => {
  const i18next = useTranslation();

  const enhancedPermissions: EnhancedPermissionsDisplayData[] = [];

  for (const permissionBlock of listOfPermissions) {
    const newPermissionBlock: EnhancedPermissionsDisplayData = {
      groupName: i18next.t(permissionBlock.groupKey),
      permissions: []
    };
    const permissionBlockIsEnabled =
      !permissionBlock.featureFlag || useFeatureFlags(permissionBlock.featureFlag as FeatureFlagNames);
    for (const permissionSet of permissionBlock.permissions) {
      const newPermissionSet: EnhancedPermissionsSet = { ...permissionSet };
      newPermissionSet.hasPermission = usePermission(permissionSet.permission ?? '');
      newPermissionSet.hasPermissionAtOwnBrewery = usePermission(permissionSet.permissionAtOwnBrewery ?? '');
      newPermissionSet.hasPermissionAtAllBreweries = usePermission(permissionSet.permissionAtAllBreweries ?? '');
      const permissionIsEnabled =
        !permissionSet.featureFlag || useFeatureFlags(permissionSet.featureFlag as FeatureFlagNames);

      if (permissionIsEnabled) {
        newPermissionBlock.permissions.push(newPermissionSet);
      }
    }

    if (permissionBlockIsEnabled) {
      enhancedPermissions.push(newPermissionBlock);
    }
  }

  return (
    <div className="user-profile-additional-settings-accordion">
      <h2>{i18next.t('userProfile.myRoles')}</h2>
      <UserInfoDisplay appName={appName} />
      <hr />
      <div className="user-profile-permissions-container">
        <div>
          {enhancedPermissions.map((permissionBlock) => (
            <div key={`permission-${permissionBlock.groupName}`}>
              <div>
                <h3>{permissionBlock.groupName}</h3>
                {permissionBlock.permissions.map((permissionSet) => (
                  <PermissionDisplayLine
                    permissionSet={permissionSet}
                    key={`permission-block-${permissionBlock.groupName}`}
                  />
                ))}
              </div>
            </div>
          ))}
        </div>
        <hr />
        <div className="user-profile-long-text">
          <Trans t={i18next.t} i18nKey="userProfile.selfService">
            <a href={userGuideLink} target="_blank" rel="noreferrer noopener">
              non-displayed text
            </a>
          </Trans>
        </div>
      </div>
    </div>
  );
};
